import { createSlice, current } from "@reduxjs/toolkit";
import { userLoggedOut } from "store/reducers/auth";
import { ID_DOC_TYPE, PROOF_OF_ADDRESS_TYPE } from "shared/enums/DocumentsTypes";

// JDD (proof_of_address) is only mandatory for Riverbank; that's checked separately
// (see hasRiverbankProvider) wherever this flag is consumed. This flag only reflects
// the always-mandatory identity document.
const moreUploadNeeded = (docs) => {
  return docs.id_docs.length === 0;
};

const slice = createSlice({
  name: "representative",
  initialState: {
    docs: {
      id_docs: [],
      proof_of_address: []
    },
    moreUploadNeeded: false,
  },
  reducers: {},
  extraReducers: {
    initDashboard: (state, { payload }) => {
      if (payload.documents) {
        payload.documents.forEach((doc) => {
          if (
            doc.owner_type.toLowerCase() === "representative" &&
            ID_DOC_TYPE.includes(doc.document_type)
          ) {
            //TODO: ce n'est pas bon nous allons avoir les id des deux type d'interlocuteurs!
            state.docs.id_docs.push(doc);
          } else if (doc.owner_type.toLowerCase() === "representative" &&
            PROOF_OF_ADDRESS_TYPE.includes(doc.document_type)) {
            state.docs.proof_of_address.push(doc);
          }
        });
      }

      state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
    },
    documentUploaded: (state, { payload }) => {
      if (payload.folder === "representative" && payload.subFolder === "id_docs") {
          state.docs.id_docs.push(payload);
        state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
      } else if (payload.folder === "representative" && payload.subFolder === "proof_of_address") {
        state.docs.proof_of_address.push(payload);
        state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
      }
    },
    documentDeleted: (state, { payload }) => {
      if (payload.folder === "representative" && payload.subFolder === "id_docs") {
        state.docs.id_docs = state.docs.id_docs.filter((x) => x.id !== payload.id);
        state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
      } else if (payload.folder === "representative" && payload.subFolder === "proof_of_address") {
        state.docs.proof_of_address = state.docs.proof_of_address.filter((x) => x.id !== payload.id);
        state.moreUploadNeeded = moreUploadNeeded(current(state).docs);
      }
    },
    [userLoggedOut.type]: (state, { payload }) => {
      state = null;
    },
  },
});

export const { documentUploaded } = slice.actions;
export default slice.reducer;
